import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Download, CreditCard, Mail } from 'lucide-react';
export function Guarantee() {
  const features = [{
    icon: Lock,
    text: 'Compra segura'
  }, {
    icon: Download,
    text: 'Descarga inmediata'
  }, {
    icon: CreditCard,
    text: 'Métodos de pago seguros'
  }, {
    icon: Mail,
    text: 'Soporte por email'
  }];
  return <section className="py-24 bg-white overflow-hidden" data-id="element-520">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-521">
        <div className="bg-combo-green rounded-[3rem] p-8 sm:p-16 relative overflow-hidden shadow-premium" data-id="element-522">
          {/* Background decorative elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-523"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-black/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3" data-id="element-524"></div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-525">
            {/* Left: Shield */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="flex-shrink-0" data-id="element-526">
              <div className="w-40 h-40 sm:w-48 sm:h-48 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center border border-white/20 shadow-glow" data-id="element-527">
                <ShieldCheck className="w-20 h-20 sm:w-24 sm:h-24 text-gold" strokeWidth={1.5} data-id="element-528" />
              </div>
            </motion.div>

            {/* Right: Content */}
            <div className="flex-1 text-center lg:text-left" data-id="element-529">
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6 tracking-tight" data-id="element-530">
                Tu satisfacción y seguridad son nuestra prioridad
              </h2>
              <p className="text-lg text-white/80 mb-10 font-light max-w-2xl" data-id="element-531">
                Comprá con total tranquilidad. Nuestro sistema de pago está
                encriptado y protegido para garantizar la seguridad de tus datos
                en todo momento.
              </p>

              <div className="grid grid-cols-2 gap-4 sm:gap-6" data-id="element-532">
                {features.map((feature, index) => <div key={index} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-xl border border-white/10" data-id="element-533">
                    <feature.icon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-534" />
                    <span className="text-sm font-medium text-white" data-id="element-535">
                      {feature.text}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}